module.exports = __webpack_public_path__ + "static/media/Location PIN.6b2c5935.svg";